import type { EventListenerMap } from '@rio-cloud/rio-uikit/EventUtils';
import Marker from '@rio-cloud/rio-uikit/Marker';
import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import type { State } from '../../reducers';
import { type POIFormValues, poiFormElements } from '../components/poi/PoiForm';
import type { Coordinates } from '../types';
import { PoiMarker } from './Markers';

interface POI {
    name: string;
    address: {
        label: string;
        position: Coordinates;
    };
}

export interface Props {
    poi?: POI;
    eventListenerMap: EventListenerMap;
}

class MapPoiRenderer extends React.Component<Props> {
    render() {
        const { poi, eventListenerMap } = this.props;
        if (!poi || !poi.address) {
            return null;
        }
        return (
            <Marker
                position={poi.address.position}
                icon={<PoiMarker name={poi.name} icon={'pushpin'} markerColor={'bg-map-marker-poi'} />}
                draggable={true}
                eventListenerMap={eventListenerMap}
            />
        );
    }
}

const mapStateToProps = (state: State) => {
    const formValues = getFormValues(poiFormElements.formName)(state) as POIFormValues;
    return {
        poi: formValues
            ? {
                  name: formValues.name,
                  address: formValues.address,
              }
            : undefined,
    };
};

const ConnectedMapPoiRenderer = connect(mapStateToProps, undefined)(MapPoiRenderer);
ConnectedMapPoiRenderer.displayName = 'ConnectedMapPoiRenderer';
export default ConnectedMapPoiRenderer;
